export { default as Label, type LabelProps } from './Label';
